import clx from 'classnames';
import type * as React from 'react';

import styled from 'styled-components';

const DrawerButtonRowContent = styled.div`
  border-top: 1px solid ${props => props.theme.colorSplit};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 24px;
`;

const DrawerButtonRowSticky = styled.div`
  z-index: 9;
  position: sticky;
  bottom: -24px;
  margin: -24px;
  margin-top: 24px;
  background: #fff;
  padding: 24px;
  padding-top: 0;

  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(4px);
  &.in-modal-dialog {
    border-radius: 0 0 8px 8px;
  }
`;

export interface DrawerButtonRowProps
  extends React.HTMLAttributes<HTMLDivElement> {
  inModalDialog?: boolean;
}

/**
 * Container per i pulsanti Salva da posizionere nei Drawer
 *
 * I pulsanti saranno posizionati a destra con un bordo superiore
 * e resteranno visibili anche se la pagina è scrollata (sticky)
 */
export function DrawerButtonRow(props: DrawerButtonRowProps) {
  return (
    <DrawerButtonRowSticky
      {...props}
      // Classe stabile per gli override scoped dei contenitori (es.
      // ConfigurationDrawerContent, che non ha padding da compensare).
      className={clx('drawer-button-row', props.className, {
        'in-modal-dialog': props.inModalDialog,
      })}
    >
      <DrawerButtonRowContent>{props.children}</DrawerButtonRowContent>
    </DrawerButtonRowSticky>
  );
}
